
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    title: {
      type: String,
      default: '',
    },
    subTitle: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hasBottomLine: {
      type: Boolean,
      default: false,
    },
  },
  setup () {
    return {}
  },
  methods: {
  },
})
